module.exports = __webpack_public_path__ + "img/9.fdf2d8f3.jpg";